import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-6 space-y-4 px-4" }
const _hoisted_2 = { class: "flex flex-col text-left" }
const _hoisted_3 = { class: "text-lg pt-1 leading-6 font-poppins text-black py-0 my-0" }
const _hoisted_4 = { class: "text-md leading-6 font-poppins text-black font-bold py-1 my-0" }
const _hoisted_5 = { class: "font-poppins text-black py-0 my-0" }

import { OutageData } from '@/services/integration/clients/types';


type OutagesList = {
  outages: Array<OutageData> | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OutageList',
  props: {
    outages: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("dl", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outages, (outage) => {
          return (_openBlock(), _createElementBlock("div", {
            key: outage.id,
            class: "relative text-left pr-14 border border-solid border-black rounded-lg px-6 py-6"
          }, [
            _createElementVNode("dt", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(outage.title), 1),
              _createElementVNode("p", _hoisted_4, "Network - " + _toDisplayString(outage.network), 1)
            ]),
            _createElementVNode("dd", _hoisted_5, _toDisplayString(outage.status), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})